import { FC } from "react";
import { useTranslation } from "@vixi/localization";
import { LanguagesIcon } from "lucide-react";
import { Img } from "@/components/base/img";
import { Outlet } from "@vixi/router";
import { Button } from "@/components/base/button";

export const AuthPageLayout: FC = () => {
  const { t, isRtl, switchLanguage } = useTranslation();

  return (
    <div className="h-screen grid grid-cols-12">
      <div className="xs:col-span-12 bg-orange-200 hidden flex-col justify-evenly ps-32.5 pe-20 lg:col-span-7 lg:flex">
        <div className="flex items-center justify-between self-stretch sm:min-w-175">
          <h1>
            {t("WelcomeToVixi")}{" "}
            <span className="text-primary">{t("CourseMaker")}</span>
          </h1>
          <Img contain src="/images/login/vixi.png" className="w-43.75" />
        </div>

        <div className="min-w-[90%] md:min-w-175">
          <h1 className="ar:max-w-auto max-w-157.5">
            {`${t("CreateAndPublish")} `}
            <span className="text-primary">{t("InMinutes")}!</span>
          </h1>
        </div>

        <div className="flex min-w-[90%] md:min-w-175">
          <Img contain src="/images/login/avatar.png" className="w-63.25" />
          <Img contain src="/images/login/screens.png" className="w-94.25" />
        </div>
      </div>

      <div className="bg-paper col-span-12 flex flex-col items-center lg:col-span-5">
        <Img contain src="/images/login/logo.png" className="w-63.75 mt-[22px]" />

        <Outlet />

        <div className="fixed start-1.25 bottom-1.25" dir={isRtl ? "ltr" : "rtl"}>
          <Button
            onClick={switchLanguage}
            startIcon={<LanguagesIcon />}
            variant="text"
            size="content"
            className="py-1.5 px-4"
          >
            {t("Sidebar.OtherLanguage")}
          </Button>
        </div>
      </div>
    </div>
  );
};
